import React from "react";
import { useDrag } from "react-dnd";
import { ItemTypes } from "../../constants/reactDnD";
import courseLabel from "../../assets/courseLabel.svg";
import {
    COURSE_LABEL_HEIGHT,
    COURSE_LABEL_WIDTH,
} from "../../constants/cssConstants";

const styles = {
    container: {
        height: COURSE_LABEL_HEIGHT,
        width: COURSE_LABEL_WIDTH,

        position: "relative",
        top: "-5px"
    },

    text: {
        position: "absolute",
        top: "10px",

        fontFamily: "Chronicle Display",
        fontSize: "14px",
        textIndent: "5px",

        color: "#000000"
    }
};

const getFormattedCourseCode = function(courseCode) {
    if(courseCode === "") {
        return "";
    }
    for(let i = 0; i < courseCode.length; i++) {
        if('A' <= courseCode.charAt(i) && courseCode.charAt(i) <= 'Z'
            && '0' <= courseCode.charAt(i+1) && courseCode.charAt(i+1) <= 9) {
            return courseCode.substring(0, i + 1) + " " + courseCode.substring(i + 1);
        }
    }
    return "";
}

function CourseLabel(props) {
    const [, drag] = useDrag({
        item: {
            id: props.courseCode,
            type: ItemTypes.COURSE_CODE
        },
        begin: () => {
            if(props.setIsDragging) {
                props.setIsDragging(true);
            }
        },
        end: (item, monitor) => {
            if(props.setIsDragging) {
                props.setIsDragging(false);
            }
            // inform the user of this component that a course is no longer here (disappear)
            if (monitor.didDrop() && props.onCourseDisappear) {
                const dropResult = monitor.getDropResult();
                props.onCourseDisappear(item.id, dropResult ? dropResult.isQuarter : false);
            }
            if(monitor.didDrop() && props.fromSearchList && props.addToPlanCoursesList) {
                props.addToPlanCoursesList(props.course);
            }
        }
    });

    return (
        <div ref={drag} style={{...styles.container, left: props.inPlanPanel ? 0 : "110px"}}>
            <img src={courseLabel} alt="Course Label" />
            <span style={styles.text}>{getFormattedCourseCode(props.courseCode)}</span>
        </div>
    );
}

export default CourseLabel;